import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { Link } from 'react-router-dom';
import Slider from "react-slick";

const Featured = (props) => {
    const [playerList, setPlayerList] = useState([]);
    const colorString = Object.values(props.theme).toString();
    useEffect(()=>{
        getApiData()
    },[])
    const getApiData = async () => {
        const apiPlayerData = await axios.get('https://appi.colexion.io/api/Player');
        const apiBowlerData = await axios.get('https://appi.colexion.io/api/Bowler');
        console.log([...apiPlayerData.data, ...apiBowlerData.data]);
        setPlayerList([...apiPlayerData.data, ...apiBowlerData.data]);
    }
    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true
              }
            }

          ]
    };
    return (
        <section className={colorString === 'true'?`customSec dark`: `customSec whiteTheme`}>
            <div className="container">
                <div className="scroller">
                    <div className="sectionHeading">
                        <div className="headingLeft">
                            <h2>Featured Sports</h2>
                            <h3>Collect exclusive licensed NFTs of your favourite cricket stars.</h3>
                        </div>
                        <div className="headingBtn">
                            <Link to="/viewall" className="customBtn2">View All <i className="fas fa-arrow-right ml-2"></i></Link>
                        </div>
                    </div>
                    <Slider {...settings}>
                        {
                            playerList.map(player =>(
                                <div className="slideWrp" key={player._id}>
                                    <div className="slideImg">
                                        <img src={`https://appi.colexion.io/${player.pflag}`} alt="" />
                                    </div>
                                    <div className="slideContent">
                                        <Link to={`details/${player._id}/Player`}>
                                            <h3>{player.name}</h3>
                                            <p>{player.tagline}</p>
                                        </Link>
                                    </div>
                                </div>
                            ))
                        }
                        
                    </Slider>
                </div>
            </div>
        </section>
    )
}
export default Featured;